import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  Inject,
  Optional,
} from "@angular/core";
import { ApiList } from "../api";
import { API_SERVICE_TOKEN, PBF_TOKEN } from "../../service/InjectionToken";
import { DashboardService } from "../dashboard.service";
import { DashboardPorletsService } from "../dashboardPorlets.service";
import { Subscription } from "rxjs";
import { getTranslation } from "../../utils/utils";

@Component({
  selector: "rs-sidebar-iconlist-new",
  templateUrl: "./sidebar-iconlist-new.component.html",
  styleUrls: ["./sidebar-iconlist-new.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarIconlistNewComponent implements OnInit {
  @Input() dashboard_sidebar: boolean = false;
  @Input() dashboard;
  @Input() dashboardId;
  @Input() activeTabId;
  @Input() activeTabLabel;
  @Input() portlets = [];
  @Input() tabactive = false;
  @Input() portlet;
  @Input() figureCode;
  @Input() _selectedX: any = [];
  @Input() _selectedY: any = [];
  @Input() _selectedMultiples: any = null;
  @Input() _selectedSecondY: any = [];
  @Input() _selectTheme: any = null;
  @Input() appCode;
  @Output() closeSidebar = new EventEmitter();
  @Output() updatePorletConfig = new EventEmitter();
  @Output() onToggleTabactive = new EventEmitter();
  @Output() updatePorlet = new EventEmitter();
  @Output() updatePushBtn = new EventEmitter();
  @Output() chartUpdate = new EventEmitter();
  @Output() updateTheme = new EventEmitter();
  public translation = getTranslation();
  private lang;
  public dataMartTableList = [];
  hasChanged = false;
  //config;
  public gadgetTitle;
  private subscriptions: Subscription[] = [];
  public portletType;
  public expandArray: Array<boolean> = [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ];
  public selectedDataTable: any = "";
  public selectedDatamart;
  public chartSettings = {
    legendSettings: {
      visible: false,
    },
    enableMultipleAxis: false,
    showMultiLevelLabels: false,
    chartSeries: {
      type: "Column",
      width: 2,
    },
    multipleAxisMode: "Stacked",
    primaryXAxis: {
      title: " ",
      majorGridLines: { width: 0 },
    },
    chartArea: {
      opacity: 0,
      border: {
        width: 0,
      },
    },
    palettes: [
      "#594bb9",
      "#f1af32",
      "#4688ed",
      "#e0563e",
      "#803a63",
      "#6dd8b5",
      "#e87225",
      "#c5df42",
      "#c6437d",
    ],
    primaryYAxis: {
      // Y轴标题设置为空
      title: " ",
    },
    zoomSettings: {
      enableMouseWheelZooming: false, // 禁用鼠标滚轮缩放
      enablePinchZooming: false, // 禁用触摸缩放
      enableSelectionZooming: false, // 禁用选择区域缩放
      enableDeferredZooming: false, // 禁用延迟缩放
      toolbarItems: [],
      enableScrollbar: false,
      enableZooming: false,
    },
  };
  public displayOption = { view: "Both", primary: "Chart" };
  public config;
  public currentTab: string = "tab1";
  public yList: any = [];
  public chartTypeList = [
    "Column",
    "Bar",
    "Line",
    "Spline",
    "Area",
    "Scatter",
    "Polar",
    "Pie",
    "Doughnut",
    "Stacked Column",
    "Radar",
  ];
  public multipleAxisModeList = ["Stacked", "Single", "Combined"];
  themeData: any = [
    {
      id: "theme13",
      value: ["#1C3484", "#35B9FC"],
    },
    {
      id: "theme14",
      value: ["#04578F", "#3EBBCE"],
    },
    {
      id: "theme15",
      value: ["#1C3484", "#136BBB", "#35B9FC"],
    },
    {
      id: "theme16",
      value: ["#04578F", "#0082AF", "#3EBBCE"],
    },
    {
      id: "theme17",
      value: ["#1C3484", "#1659A9", "#1D97E1", "#35B9FC"],
    },
    {
      id: "theme18",
      value: ["#04578F", "#0070A3", "#16A2C2", "#3EBBCE"],
    },
    {
      id: "theme19",
      value: ["#1C3484", "#1659A9", "#1375C4", "#1D97E1", "#35B9FC"],
    },
    {
      id: "theme20",
      value: ["#04578F", "#0070A3", "#0089B4", "#16A2C2", "#3EBBCE"],
    },
    {
      id: "theme21",
      value: ["#1C3484", "#1659A9", "#1368B8", "#1375C4", "#1D97E1", "#35B9FC"],
    },
    {
      id: "theme22",
      value: ["#04578F", "#0070A3", "#007FAD", "#0089B4", "#16A2C2", "#3EBBCE"],
    },
    {
      id: "theme23",
      value: [
        "#1C3484",
        "#1659A9",
        "#145FAF",
        "#1368B8",
        "#1375C4",
        "#1D97E1",
        "#35B9FC",
      ],
    },
    {
      id: "theme24",
      value: [
        "#04578F",
        "#0070A3",
        "#0078A9",
        "#007FAD",
        "#0089B4",
        "#16A2C2",
        "#3EBBCE",
      ],
    },
    {
      id: "theme11",
      value: [
        "#1C3484",
        "#194697",
        "#1659A9",
        "#136BBB",
        "#147ECC",
        "#1B92DD",
        "#26A5ED",
        "#35B9FC",
      ],
    },
    {
      id: "theme12",
      value: [
        "#04578F",
        "#00659B",
        "#0073A6",
        "#0082AF",
        "#0090B8",
        "#0F9EC0",
        "#29ADC7",
        "#3EBBCE",
      ],
    },
    {
      id: "theme1",
      value: [
        "#594bb9",
        "#f1af32",
        "#4688ed",
        "#e0563e",
        "#803a63",
        "#6dd8b5",
        "#e87225",
        "#c5df42",
        "#c6437d",
      ],
    },
    {
      id: "theme2",
      value: [
        "#4688ed",
        "#f1af32",
        "#e0563e",
        "#803a63",
        "#6dd8b5",
        "#e87225",
        "#c5df42",
        "#c6437d",
        "#594bb9",
      ],
    },
    {
      id: "theme3",
      value: [
        "#c6437d",
        "#c5df42",
        "#e87225",
        "#6dd8b5",
        "#e0563e",
        "#803a63",
        "#f1af32",
        "#594bb9",
        "#4688ed",
      ],
    },
    {
      id: "theme4",
      value: [
        "#2f499f",
        "#8d1d2e",
        "#e9bf35",
        "#51772f",
        "#469bd8",
        "#5c448f",
        "#da732f",
        "#245353",
        "#43a245",
      ],
    },
    {
      id: "theme5",
      value: [
        "#383839",
        "#446ec6",
        "#cf6384",
        "#ebb37e",
        "#71a249",
        "#4bb1a5",
        "#e87225",
        "#c5df42",
        "#c6437d",
      ],
    },
    {
      id: "theme6",
      value: [
        "#517ae1",
        "#6386e5",
        "#7491e9",
        "#849dec",
        "#94a9ef",
        "#a4b6f2",
        "#b4c3f6",
        "#c4cff9",
        "#d4ddfd",
      ],
    },
    {
      id: "theme7",
      value: [
        "#39828e",
        "#488e99",
        "#579aa5",
        "#66a6b0",
        "#75b3bd",
        "#85bfc9",
        "#95cdd6",
        "#a4dae2",
        "#b5e8f0",
      ],
    },
    {
      id: "theme8",
      value: [
        "#e7963d",
        "#ea9e4b",
        "#eea659",
        "#f0ae68",
        "#f2b678",
        "#f3bf87",
        "#f5c798",
        "#f6d0aa",
        "#f7d9bb",
      ],
    },
    {
      id: "theme9",
      value: [
        "#64a8b4",
        "#7ebec0",
        "#9cc9ca",
        "#b8d4d4",
        "#d9d6cd",
        "#d8b7a7",
        "#ce8f93",
        "#c1627f",
        "#ad2458",
      ],
    },
    {
      id: "theme10",
      value: [
        "#4176ba",
        "#559ae8",
        "#70b3e8",
        "#a7cce7",
        "#dfdfdf",
        "#d2a08b",
        "#c76a50",
        "#ca4e34",
        "#aa3c29",
      ],
    },
  ];

  public themeFields: Object = { text: "value", value: "id" };

  constructor(
    private api: ApiList,
    public dashboardService: DashboardService,
    public dashboardPorletsService: DashboardPorletsService,
    private ref: ChangeDetectorRef,
    @Optional() @Inject(PBF_TOKEN) private pbf: any,
    @Optional() @Inject(API_SERVICE_TOKEN) private http: any
  ) {}
  ngOnInit() {
    this.currentTab = this.tabactive ? "tab1" : "tab2";
    this.getInfo();
    this.setDatabind();
    this.initHistoricalIRROptions();
    this.getmultiplesList();
  }

  ngOnChanges() {
    this.ref.markForCheck(); // 标记为需要检测
  }
  ngAfterViewInit(): void {
    this.subscriptions.push(
      this.dashboardService.getPushbtn().subscribe((id) => {
        if (this.dashboard && this.dashboard.id === id) {
          this.config = this.getConfig([]);
          this.selectedDatamart = "";
          this.selectedX = null;
          this.selectedY = [];
          this.selectedSecondY = [];
          this.selectedMultiples = null;
          this.ref.markForCheck();
          this.ref.detectChanges();
        }
      })
    );

    this.subscriptions.push(
      this.dashboardService.getportletEdit().subscribe((dashboardId) => {
        if (dashboardId === this.dashboardId) {
          this.setDatabind();
        }
      })
    );
    this.initDataMartTableList();
  }

  private initDataMartTableList() {
    this.dataMartTableList = [...this.dashboard.dataMartTables].filter(
      (item) => !item.isHide
    );

    this.dashboardPorletsService.renameDataMartTables(
      this.dataMartTableList,
      this.dashboard.id,
      this.dashboard.entityType
    );
    this.dashboardPorletsService.sortDataMartTables(this.dataMartTableList);
    if (!this.portlet) {
      return;
    }
    let figureCode = this.portlet.figureCode;
    this.dashboard.dataMartTables.forEach((item) => {
      if (item.datamartCode === figureCode && item.prefix) {
        figureCode = item.prefix;
      }
    });
    if (
      !this.dataMartTableList.find((item) => item.datamartCode === figureCode)
    ) {
      this.dataMartTableList.forEach((data) => {
        if (data.prefix === figureCode) {
          figureCode = data.datamartCode;
        }
      });
    }

    this.selectedDatamart = figureCode;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }

  public nextWizard(wizard: number) {
    if (!this.expandArray[wizard]) {
      this.expandArray = [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ];
      this.expandArray[wizard] = true;
    } else {
      this.expandArray[wizard] = false;
    }
  }

  private getInfo() {
    this.translation = getTranslation();
    this.lang = this.pbf.getLanguageParams();
  }

  public clear() {
    this.dashboardService.clearSidebar.next(true);
  }
  public close() {
    this.updatePushBtn.emit(false);
    this.updatePorlet.emit(null);
    this.closeSidebar.emit(false);
  }

  public getFigurecode() {
    let codeArr = ["Tasks", "FundList", "IRR", "Notes"];
    let i = codeArr.indexOf(this.figureCode);
    return i > -1 ? false : true;
  }

  // 图表类型更改event
  public getPortletType($event) {
    this.portletType = $event;
    this.hasChanged = this.config.portletType !== this.portletType;
    const prevType = this.config.portletType;
    this.config.portletType = this.portletType;
    if (!$event) {
      return;
    }
    if (["newcolumn", "newline", "newcolumnline"].includes($event)) {
      this.selectedX = null;
      this.selectedY = [];
      this.selectedSecondY = [];
      this.selectedMultiples = null;
      this.expandArray[2] = false;
      this.expandArray[7] = true;
      // 修复有时选择 xy 轴时没有数据的问题
      if (this.portlet && this.portlet.figureCode) {
        this.getData(this.portlet.figureCode, false, this.portletType);
      }
      return;
    }
    if (this.portletType === "newchart") {
      if (
        this.config.pvtableChartSetting &&
        this.config.pvtableChartSetting.chartSettings
      ) {
        this.chartSettings = {
          ...this.config.pvtableChartSetting.chartSettings,
        };
      } else {
        this.chartSettings = {
          legendSettings: {
            visible: false,
          },
          enableMultipleAxis: false,
          showMultiLevelLabels: false,
          chartSeries: {
            type: "Column",
            width: 2,
          },
          multipleAxisMode: "Stacked",
          primaryXAxis: {
            title: " ",
            majorGridLines: { width: 0 },
          },
          chartArea: {
            opacity: 0,
            border: {
              width: 0,
            },
          },
          palettes: [
            "#594bb9",
            "#f1af32",
            "#4688ed",
            "#e0563e",
            "#803a63",
            "#6dd8b5",
            "#e87225",
            "#c5df42",
            "#c6437d",
          ],
          primaryYAxis: {
            // Y轴标题设置为空
            title: " ",
          },
          zoomSettings: {
            enableMouseWheelZooming: false, // 禁用鼠标滚轮缩放
            enablePinchZooming: false, // 禁用触摸缩放
            enableSelectionZooming: false, // 禁用选择区域缩放
            enableDeferredZooming: false, // 禁用延迟缩放
            toolbarItems: [],
            enableScrollbar: false,
            enableZooming: false,
          },
        };
      }
    }
    if ($event === "historicalIRR") {
      this.onSelectedHistoricalIRRPortlet();
      this.expandArray[2] = false;
      this.expandArray[7] = true;
      return;
    }
    this.expandArray[2] = false;
    this.expandArray[3] = true;
    if (this.portletType) {
      this.AddOrEditPortlet();
    }
  }
  public changeDataTable(value) {
    this.selectedDataTable = this.dataMartTableList.filter(
      (el) => el.datamartCode === value
    )[0].id;
    this.selectedDatamart = value;
    if (this.portlet) {
      this.portlet.figureCode = value;

      this.portlet.dashboardDataTableId = this.getSelectDatamartId();
    }
    if (this.portlet) {
      this.dashboardService.clearFieldList.next(this.portlet.newId);
    }
    if (this.portlet) {
      this.dashboardPorletsService.clearFieldsObj(this.portlet);
    }
    this.getData(value);
    this.expandArray[0] = false;
    this.expandArray[2] = true;
  }

  _updatePorletConfig(e) {
    this.updatePorletConfig.emit(e);
  }

  private getData(code, edit: boolean = true, portletType = "") {
    const dataObj = {
      dataMartCode: code,
      language: this.lang,
    };
    this.dashboardPorletsService.setSchemaParams(dataObj, code, this.dashboard);
    this.http.post(this.api.urlList.GetSchema, dataObj, (res) => {
      if (res) {
        if (
          [
            "SeeThroughQuarterly",
            "SeeThroughYearly",
            "SeeThroughMonthly",
          ].includes(code)
        ) {
          res = res.filter(
            (item) =>
              ![
                "CI_MTD",
                "CI_QTD",
                "CI_YTD",
                "CTWR_MTD",
                "CTWR_QTD",
                "CTWR_YTD",
                "CVAR_MTD_95",
                "CVAR_MTD_99",
                "CVAR_QTD_95",
                "CVAR_QTD_99",
                "CVAR_YTD_95",
                "CVAR_YTD_99",
              ].includes(item.colName)
          );
        }
        if (!this.dashboardPorletsService.fieldsArr[this.dashboard.id]) {
          this.dashboardPorletsService.fieldsArr[this.dashboard.id] = {};
        }
        this.dashboardPorletsService.fieldsArr[this.dashboard.id][
          this.selectedDatamart
        ] = res;
        if (this.portlet) {
          if (this.portlet.config) {
            this.config = JSON.parse(this.portlet.config);
          } else {
            this.config = {};
          }
          if (portletType) {
            this.config.portletType = portletType;
          }
          this.config.fields = res;

          // TO DO 过滤Y轴的数据
          this.yList = res;
          this.portlet.config = this.config ? JSON.stringify(this.config) : "";

          edit && this.AddOrEditPortlet();
        } else {
          this.config.fields = res;
          setTimeout(() => {
            const portlet = Object.assign({}, this.portlet);
            portlet.config = this.config;
            this.updatePorlet.emit(portlet);
            // TO DO 过滤Y轴的数据
            this.yList = res;
          });
        }
      }
    });
  }

  public setMultipleAxis(e) {
    setTimeout(() => {
      if (!this.chartSettings.enableMultipleAxis) {
        this.chartSettings.legendSettings.visible = false;
        this.ref.markForCheck();
      }
      this.dashboardService.enableMultipleAxisChange.next({
        newId: this.portlet.newId,
        enableMultipleAxis: this.chartSettings.enableMultipleAxis,
        visible: this.chartSettings.legendSettings.visible,
        multipleAxisMode: this.chartSettings.multipleAxisMode,
      });
    });
  }

  public setChartType() {
    const portlet = Object.assign({}, this.portlet);
    if (portlet.config) {
      const config = JSON.parse(portlet.config);
      config.pvtableChartSetting = config.pvtableChartSetting
        ? {
            ...config.pvtableChartSetting,
            chartSettings: this.chartSettings,
          }
        : { chartSettings: this.chartSettings };
      portlet.config = JSON.stringify(config);
    }
    this.updatePorlet.emit(portlet);
    setTimeout(() => {
      this.dashboardService.chartTypeChange.next({
        newId: this.portlet.newId,
        chartSettings: this.chartSettings,
      });
    });
  }

  public getThemeData(e) {
    const id = e.value;
    const portlet = this.portlet;
    const theme = this.themeData.find((item) => item.id === id);
    if (!theme) {
      return;
    }
    this.dashboardService.setTheme.next({
      newId: portlet.newId,
      theme: theme.value,
    });
  }

  public AddOrEditPortlet() {
    const portletType =
      this.config.portletType === "historicalIRR"
        ? this.config.selectedVisualType
        : this.config.portletType;
    if (this.portlet && this.portlet.newId) {
      // SMP2-17654 需要将选择的 frequency、investor、visual type 保存到 config 中用来拿取后端数据
      // 但是如果直接保存 this.config 会出现 SMP2-18837 这个 BUG
      const config = JSON.parse(this.portlet.config);
      if (this.hasChanged) {
        if (
          ["newcolumn", "newline", "newcolumnline"].includes(portletType) &&
          (this.selectedY.length > 0 || this.selectedSecondY.length > 0)
        ) {
          config["selectedX"] = this.selectedX;
          config["selectedY"] = this.selectedY;
          config["selectedSecondY"] = this.selectedSecondY;
          config["selectedMultiples"] = this.selectedMultiples;
          config["selectTheme"] = this.selectTheme;
        }

        if (config.portletType === "newchart") {
          config.pvtableChartSetting = {
            chartSettings: this.chartSettings,
            displayOption: this.displayOption,
          };
        }
      }
      config.selectedMultiples = this.config.selectedMultiples;
      config.selectedInvestor = this.config.selectedInvestor;
      config.selectedVisualType = this.config.selectedVisualType;
      const portlet = Object.assign({}, this.portlet);
      portlet.config = JSON.stringify(config);
      // 新增DataTable类型， 编辑Porlet
      this.dashboardPorletsService.setDataManager(
        [this.getTrueSelectedDatamart()],
        (res) => {
          this.pbf.pageLoading = false;
          this.pbf.pageLoading_.next(true);
          this.editPortlet();
        },
        [portletType],
        this.dashboard.id,
        portlet
      );
    } else {
      this.config.fields.map((el) => {
        el.visible = true;
      });
      if (
        ["newcolumn", "newline", "newcolumnline"].includes(portletType) &&
        (this.selectedY.length > 0 || this.selectedSecondY.length > 0)
      ) {
        this.config["selectedX"] = this.selectedX;
        this.config["selectedY"] = this.selectedY;
        this.config["selectedSecondY"] = this.selectedSecondY;
        this.config["selectedMultiples"] = this.selectedMultiples;
        this.config["selectTheme"] = this.selectTheme;
      }

      if (this.config.portletType === "newchart") {
        this.config.pvtableChartSetting = {
          chartSettings: this.chartSettings,
          displayOption: this.displayOption,
        };
      }

      this.getSelectDatamartId();
      const portletdata = {
        id: "00000000-0000-0000-0000-000000000000",
        newId: "portlet_" + this.pbf.Guid(),
        dashboardDataTableId: this.getSelectDatamartId(),
        figureCode: this.getTrueSelectedDatamart(),
        col: 0,
        row: 0,
        sizeX: 2,
        sizeY: 1,
        posX: 0,
        posY: 0,
        height: 1,
        width: 2,
        config: JSON.stringify(this.config),
      };
      this.updatePorlet.emit(portletdata);
      this.portlets.forEach((portlet) => {
        portlet.row += 1;
      });
      // 新增DataTable类型， 新增Porlet
      this.dashboardPorletsService.setDataManager(
        [this.getTrueSelectedDatamart()],
        (res) => {
          setTimeout(() => {
            this.dashboardService.addOrdelPortlet.next(this.dashboard.id);
            this.pbf.pageLoading = false;
            this.pbf.pageLoading_.next(true);
          }, 200);
        },
        [portletType],
        this.dashboard.id,
        portletdata
      );
    }
  }
  private editPortlet() {
    if (this.portlet) {
      const portletType =
        this.config.portletType === "historicalIRR"
          ? this.config.selectedVisualType
          : this.config.portletType;
      if (["table", "transpose", "financialTable"].includes(portletType)) {
        this.config.filterSettings = [];
        this.config.fields.map((el) => {
          el.visible = true;
        });
      }
      const index = this.portlets.findIndex(
        (x) => x.newId === this.portlet.newId
      );
      if (index > -1) {
        this.portlets[index].config = JSON.stringify(this.config);

        if (["newcolumn", "newline", "newcolumnline"].includes(portletType)) {
          this.portlets[index].figureCode = this.getTrueSelectedDatamart();
        }

        const portlet = Object.assign({}, this.portlet);
        portlet.config = JSON.stringify(this.config);
        portlet.dashboardDataTableId = this.getSelectDatamartId();
        this.updatePorlet.emit(portlet);
      }
      const id = this.portlet.id || this.portlet.newId;
      this.chartUpdate.emit(id);
    }
  }

  switchTab(type) {
    this.currentTab = type;
    this.onToggleTabactive.emit(!this.tabactive);
    this.dashboardService.portletEdit.next(this.dashboardId);
  }

  gadgetTitleChange(newObj) {
    if (!this.portlet || !this.portlet.config) {
      return;
    }
    this.config = JSON.parse(this.portlet.config);
    this.config.gadgetTitle = newObj;
    const index = this.portlets.findIndex(
      (x) => x.newId === this.portlet.newId
    );
    if (index > -1) this.portlets[index].config = JSON.stringify(this.config);
    this.portlet.config = JSON.stringify(this.config);
    this.dashboardService.portletTitle.next(true);
  }

  setDatabind() {
    if (this.portlet) {
      const { dataMartTables = {} } = this.dashboardPorletsService;
      let figureCode = this.portlet.figureCode;
      dataMartTables[this.dashboard.id].forEach((item) => {
        if (item.datamartCode === figureCode && item.prefix) {
          figureCode = item.prefix;
        }
      });
      if (
        this.dataMartTableList &&
        this.dataMartTableList.length &&
        !this.dataMartTableList.find((item) => item.datamartCode === figureCode)
      ) {
        this.dataMartTableList.forEach((data) => {
          if (data.prefix === figureCode) {
            figureCode = data.datamartCode;
          }
        });
      }

      this.selectedDatamart = figureCode;
      this.config = {};
      if (this.portlet.config) this.config = JSON.parse(this.portlet.config);
      this.hasMarker = this.config.hasMarker;
      this.markerFormat = this.config.markerFormat || "";

      if (this.config.portletType === "historicalIRR") {
        this.selectedMultiples = this.config.selectedMultiples;
        this.selectedInvestor = this.config.selectedInvestor;
        this.selectedVisualType = this.config.selectedVisualType;
        this.portletType = this.config.portletType;
      }
      const portletType =
        this.config.portletType === "historicalIRR"
          ? this.config.selectedVisualType
          : this.config.portletType;
      if (["newcolumn", "newline", "newcolumnline"].includes(portletType)) {
        this.selectedX = this._selectedX;
        this.selectedY = this._selectedY;
        this.selectedSecondY = this._selectedSecondY;
        this.selectedMultiples = this._selectedMultiples;
        this.selectTheme = this._selectTheme;
        this.portletType = this.config.portletType;
        this.getData(this.portlet.figureCode, false);
      }

      if (this.config.portletType === "newchart") {
        this.portletType = "newchart";
        if (this.config.pvtableChartSetting) {
          this.chartSettings = {
            ...this.config.pvtableChartSetting.chartSettings,
          };
          if (this.config.pvtableChartSetting.chartSettings.palettes) {
            const { palettes } = this.config.pvtableChartSetting.chartSettings;
            if (palettes && palettes.length) {
              this.selectTheme = this.themeData.find(
                (item) =>
                  // 用于判断两个
                  JSON.stringify(item.value) === JSON.stringify(palettes)
              ).id;
            }
          }
        } else {
          this.config.pvtableChartSetting = {
            displayOption: this.displayOption,
            chartSettings: this.chartSettings,
          };
        }
      }
    } else {
      this.selectedDatamart = "";
      this.config = this.getConfig([]);
    }
    this.ref.markForCheck();
    this.ref.detectChanges();
  }
  private getConfig(fields) {
    return {
      tabId: this.activeTabId,
      tabLabel: this.activeTabLabel,
      portletType: "",
      gadgetTitle: "",
      isUpToDate: false,
      period: 3,
      pagebreak: false,
      timeMeasure: "MTD",
      series: [],
      sSeries: [],
      trendsOrder: 1,
      showTrends: true,
      numberFormat: "#,##0",
      showCurrentData: false,
      fields: fields,
      allFields: [
        {
          colName: "ALL_TEXT_FIELDS",
          langValue: "All text fields",
          dataType: "string",
        },
        {
          colName: "ALL_DATE_FIELDS",
          langValue: "All date fields",
          dataType: "date",
        },
        {
          colName: "ALL_NUMBER_FIELDS",
          langValue: "All number fields",
          dataType: "number",
        },
        {
          colName: "ALL_INTEGER_FIELDS",
          langValue: "All integer fields",
          dataType: "integer",
        },
        {
          colName: "ALL_PERCENTAGE_FIELDS",
          langValue: "All percentage fields",
          dataType: "percent",
        },
        {
          colName: "ALL_MULTIPLE_FIELDS",
          langValue: "All multiple fields",
          dataType: "multiple",
        },
      ],
      filters: [],
      filterSettings: [],
      columnGroup: [],
      listOfInvesteeId: [],
      investeeId: "00000000-0000-0000-0000-000000000000",
      groupBy: "",
      groups: [],
      asOfDate: "",
      currencyCode: "",
      fundId: "00000000-0000-0000-0000-000000000000",
      xaxis: { groups: [] },
      yaxis: {
        series: [{ portletType: "", colName: "", calMethod: "" }],
      },
      calculatedFieldSettings: [],
      columnsWidth: [],
      sortSettings: [],
      groupSettings: [],
      valueSortSettings: {},
      showGrandTotals: true,
      showRowGrandTotals: true,
      showColumnGrandTotals: true,
      showSubTotals: true,
      showRowSubTotals: true,
      showColumnSubTotals: true,
    };
  }

  public selectedInvestor = null;
  public investorList = [];
  public selectedVisualType = null;
  public visualTypeList = [];

  // historical IRR frequency 不需要 Daily
  get frequencyOptions() {
    return this.multiplesList.filter((i) => i.langCode !== "DAILY");
  }

  initHistoricalIRROptions() {
    const chartText = this.translation.COMPANY_CHART || ".COMPANY_CHART";
    this.investorList = [
      {
        code: "All",
        text: this.translation.ALL,
      },
      {
        code: "ExcludeGP&SLP",
        text: this.translation["EXCLUDE_GP&SLP"] || ".Exclude GP&SLP",
      },
    ];
    this.visualTypeList = [
      {
        code: "newline",
        text: `${this.translation.LINE || ".LINE"} ${chartText}`,
      },
      {
        code: "newcolumn",
        text: `${this.translation.COLUMN} ${chartText}`,
      },
      {
        code: "table",
        text: this.translation.TABLE || ".TABLE",
      },
    ];
  }

  onSelectedHistoricalIRRPortlet() {
    this.selectedInvestor = "All";
    this.selectedMultiples = "QUARTERLY";
    this.selectedVisualType = "newline";
    this.setHistoricalIRRChart(false);
  }

  setHistoricalIRRChart(opened: boolean) {
    if (opened) {
      return;
    }
    if (
      this.selectedVisualType !== "table" &&
      this.config.selectedVisualType === "table"
    ) {
      this.hasMarker = false;
    }

    this.config.selectedVisualType = this.selectedVisualType;
    this.config.selectedInvestor = this.selectedInvestor;
    if (this.selectedVisualType !== "table") {
      // 这里确定 x、y 轴字段名称
      this.selectedX = "Date";
      this.selectedY = ["IRR"];
      return this.xyChange(false);
    } else {
      this.config.selectedMultiples = this.selectedMultiples;
      this.AddOrEditPortlet();
    }
  }

  selectedX: any = null;
  selectedY: any = [];
  selectedSecondY: any = [];
  selectedMultiples: any = null;
  markerFormat = "";
  markerFormatList = [
    {
      value: "",
      label: this.translation.NONE || ".None",
    },
    {
      value: "K",
      label: this.translation.THOUSANDS || ".Thousands",
    },
    {
      value: "M",
      label: this.translation.MILLIONS || ".Millions",
    },
    {
      value: "bn",
      label: this.translation.BILLIONS || ".Billions",
    },
    {
      value: "T",
      label: this.translation.TRILLIONS || ".Trillions",
    },
  ];
  hasMarker = false;

  labelConfigChange(e) {
    this.config.hasMarker = e;
    this.updatePorletConfig.emit({
      newId: this.portlet.newId,
      config: Object.assign({}, this.config),
    });
    this.dashboardService.switchLabelConfig.next({
      checked: e,
      id: this.portlet.newId,
    });
  }

  xyChange(e) {
    if (e) {
      return;
    }

    setTimeout(() => {
      this.updateTheme.emit({
        selectedX: this.selectedX,
        selectedY: this.selectedY,
        selectedMultiples: this.selectedMultiples,
        selectedSecondY: this.selectedSecondY,
        selectTheme: this.selectTheme,
        hasMarker: this.hasMarker,
        markerFormat: this.markerFormat,
      });

      this.config["markerFormat"] = this.markerFormat;
      this.config["hasMarker"] = this.hasMarker;
      this.config["selectedX"] = this.selectedX;
      this.config["selectedY"] = this.selectedY;
      this.config["selectedSecondY"] = this.selectedSecondY;
      this.config["selectedMultiples"] = this.selectedMultiples;
      this.config["selectTheme"] = this.selectTheme;

      this.updatePorletConfig.emit({
        newId: this.portlet.newId,
        config: Object.assign({}, this.config),
      });

      this.showEdit();
    }, 500);
  }

  showEdit() {
    if (
      this.portletType == "newcolumnline" &&
      this.selectedY.length > 0 &&
      this.selectedSecondY.length > 0
    ) {
      this.AddOrEditPortlet();
    }
    if (this.portletType != "newcolumnline" && this.selectedY.length > 0) {
      this.AddOrEditPortlet();
    }
  }

  multiplesList: any = [];
  getmultiplesList() {
    const url =
      this.appCode === "PMS"
        ? this.api.urlList.LPGetPropertyList
        : this.api.urlList.GetPropertyList;
    this.http.post(url, { scope: "DASHBOARD_FREQUENCY", langIdx: 2 }, (res) => {
      this.multiplesList = res;
    });
  }

  capitalize(str) {
    // 将字符串转换为小写，并使用正则表达式将每个单词的第一个字符转换为大写
    if (!str) {
      return;
    }
    return str.toLowerCase().replace(/\b\w/g, function (char) {
      return char.toUpperCase();
    });
  }

  getSelectDatamartId() {
    // 获取真正的DatamartID
    const code = this.getTrueSelectedDatamart();
    let dataMartTables = this.dashboardPorletsService.dataMartTables[
      this.dashboard.id
    ].filter((el) => code == el.datamartCode);
    if (dataMartTables.length > 0) {
      return dataMartTables[0].id;
    }
  }

  getTrueSelectedDatamart() {
    const portletType =
      this.config.portletType === "historicalIRR"
        ? this.config.selectedVisualType
        : this.config.portletType;
    // 获取真正的DatamartCode
    if (["newcolumn", "newline", "newcolumnline"].includes(portletType)) {
      return this.getSelectDatamartCode();
    } else {
      return this.selectedDatamart;
    }
  }

  getSelectDatamartCode() {
    const item = this.dashboardPorletsService.dataMartTables[
      this.dashboard.id
    ].filter((e) => {
      return e["datamartCode"] == this.selectedDatamart;
    });
    if (item.length > 0) {
      if (item[0]["prefix"]) {
        return `${item[0]["prefix"]}${
          this.capitalize(this.selectedMultiples) || ""
        }`;
      } else {
        return item[0]["datamartCode"];
      }
    } else {
      return "";
    }
  }

  selectTheme: any = "theme1";
  changeTheme(e, type) {
    this.selectTheme = e.value;
    this.config["selectTheme"] = this.selectTheme;
    this.updateTheme.emit({
      selectedX: this.selectedX,
      selectedY: this.selectedY,
      selectedMultiples: this.selectedMultiples,
      selectedSecondY: this.selectedSecondY,
      selectTheme: this.selectTheme,
    });
    this.showEdit();
  }

  sortDataMartTables(data) {
    data.sort((a, b) => {
      const langValueA = a.langValue.toLowerCase();
      const langValueB = b.langValue.toLowerCase();

      if (langValueA < langValueB) {
        return -1;
      }
      if (langValueA > langValueB) {
        return 1;
      }
      return 0;
    });
  }

  onChangeFormat() {
    this.dashboardService.markerFormat.next({
      newId: this.portlet.newId,
      markerFormat: this.markerFormat,
    });
  }
}
